import { render, staticRenderFns } from "./Integra.vue?vue&type=template&id=660e1179&scoped=true"
import script from "./Integra.vue?vue&type=script&lang=js"
export * from "./Integra.vue?vue&type=script&lang=js"
import style0 from "./Integra.vue?vue&type=style&index=0&id=660e1179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660e1179",
  null
  
)

export default component.exports